import React from "react";
import { columns } from "../../../../dtos/columns";
import { ResponseDeudaDto } from "../models";
import { Checkbox } from '@mui/material';

interface IProps {
  controlTabla: any;
  idsMutuos: string[]; // AHORA: claves compuestas
  setIdsMutuos: React.Dispatch<React.SetStateAction<string[]>>;
}

export function useColumnsLiquidacionDeuda({ controlTabla, idsMutuos, setIdsMutuos }: IProps) {
  const COLUMNS: columns<ResponseDeudaDto>[] = [
    {
        name: (
        <Checkbox
            size="small"
            checked={
              controlTabla?.data?.length > 0 &&
              idsMutuos.length === controlTabla.data.length
            }
            indeterminate={
              idsMutuos.length > 0 &&
              idsMutuos.length < (controlTabla?.data?.length ?? 0)
            }
            onChange={e => {
            if (e.target.checked && controlTabla?.data) {
                setIdsMutuos(controlTabla.data.map((item: ResponseDeudaDto) => item.operacionHipo));
            } else {
                setIdsMutuos([]);
            }
            }}
        />
        ),
        selector: (row: ResponseDeudaDto) => row.operacionHipo,
        cell: (row: ResponseDeudaDto) => (
        <Checkbox
            size="small"
            checked={idsMutuos.includes(row.operacionHipo)}
            onChange={e => {
            setIdsMutuos(prev =>
                e.target.checked
                ? [...prev, row.operacionHipo]
                : prev.filter(id => id !== row.operacionHipo)
            );
            }}
        />
      ),
      allowOverflow: true,
      button: true,
      export: false,
      width: "60px",
    },
    {
      name: "Mutuo",
      selector: (row: ResponseDeudaDto) => row.mutuoTipo?.toString() || '',
      sortable: true,
      sortField: "mutuoTipo",
      wrap: true,
      export: true,
    },
    {
      name: "Identificación de mutuo",
      selector: (row: ResponseDeudaDto) => row.operacionHipo?.toString() || '',
      sortable: true,
      sortField: "operacionHipo",
      wrap: true,
      export: true,
    },
    {
      name: "ID complementario",
      selector: (row: ResponseDeudaDto) => row.operacionComple?.toString() || '',
      sortable: true,
      sortField: "operacionComple",
      wrap: true,
      export: true,
    },
  ]

  return { COLUMNS };
}
